/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetComparisonDesktopRequest,
  TGetComparisonDesktopModel,
  IMappers,
  TGetComparisonDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetComparisonDesktopResponse } from '../../entities/get_comparison_desktop/GetComparisonDesktopResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetComparisonDesktopModel(parameters: IGetComparisonDesktopRequest): TGetComparisonDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'offers-comparison',
    pathApi: '/v2/get-comparison-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetComparisonDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetComparisonDesktopRequest;
}

export async function fetchGetComparisonDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetComparisonDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetComparisonDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetComparisonDesktopModel(parameters),
    config,
  )) as FetchResponse<TGetComparisonDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetComparisonDesktopResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetComparisonDesktopResponse>;
}
